import React from 'react';

import {HandlerOf} from '../../../../../libs/shared/helpers/src/react/reactHelpers';
import {OrNull} from '../../../../../libs/shared/helpers/src/typescript/typeHelpers';
import {
  DropdownWithExpressions,
  DropdownWithExpressionsBaseProps,
  LikeId,
  SelectedDropdownItem,
} from './dropdownWithExpressions';
import {
  MultipleGroupsDropdownBoxWithAnyHeaderProps,
  MultipleGroupsDropdownBoxWithoutAnyHeaderProps,
} from './multipleGroupsDropdownBox';

interface SingleChoiceDropdownBaseProps<T extends LikeId> {
  selectedItem: OrNull<SelectedDropdownItem<T>>;
  onChange: HandlerOf<OrNull<SelectedDropdownItem<T>>>;
}

export type SingleChoiceDropdownProps<T extends LikeId> = SingleChoiceDropdownBaseProps<T> &
  Omit<DropdownWithExpressionsBaseProps<T>, 'selectedItems' | 'onChange'> &
  (MultipleGroupsDropdownBoxWithoutAnyHeaderProps<T> | MultipleGroupsDropdownBoxWithAnyHeaderProps<T>);

export const SingleChoiceDropdown = <T extends LikeId>(props: SingleChoiceDropdownProps<T>) => {
  const onChange = (selectedItems: OrNull<ReadonlyArray<SelectedDropdownItem<T>>>) =>
    props.onChange(selectedItems ? selectedItems[0] : null);

  return (
    <DropdownWithExpressions
      {...props}
      onChange={onChange}
      selectedItems={props.selectedItem ? [props.selectedItem] : null}
    />
  );
};
